<template>
 <div class="ml-4 mr-4 mb-2">
	<h1 class="ml-4">Lieferanten</h1>
	<div class="grid">
		<div class="card col p-2 m-2 ml-4">
			<div class="d-flex flex-row">
				<input type="text" v-model="searchQuery" placeholder="Suche (Name, Nr., Land, Kontakt)" class="form-control m-2"/>
				<select v-model="activeState" class="form-control m-2">
					<option value="">Alle Status</option>
					<option value="1">aktiv</option>
					<option value="0">inaktiv</option>
				</select>
				<select v-model="deliveryClass" class="form-control m-2">
					<option selected :value="null">Alle Lieferklassen</option>

					<option
							v-for="option in deliveryClassOptions"
							:key="option.value"
							:value="option.value"
					>
						{{ option.text }}
					</option>
				</select>
			</div>
			<div class="overflow-auto hide-scrollbar" style="max-height: 80vh;">
				<vendor-list-item
					v-for="vendor in filteredVendors"
					:key="vendor.id"
					:vendor="vendor"
					:country="countries[vendor.countryId]"
					@click="selectVendor(vendor)"
					:is-selected="selectedVendor && selectedVendor.id === vendor.id"
					:disabled="isVendorEditing"
				/>
			</div>
		</div>
		<div>
			<VendorDetailCmp
			:passed-vendor="selectedVendor"
			:addresses="addresses"
			:currencies="currencies"
			:countries="countries"
			:delivery-classes="deliveryClasses"
			:delivery-groups="deliveryGroups"
			:main-vendors="mainVendors"
			class="col-11"
			@edit-mode-change="handleVendorEditModeChange"
			:active-tab="activeVendorDetailTab"
			@update:activeTab="activeVendorDetailTab = $event" />
		</div>
	</div>
 </div>
</template>

<script>
import VendorDetailCmp from "./VendorDetailCmp.vue";
import VendorListItem from "./VendorListItem.vue";

export default {
	name: "VendorList",
	components: {VendorListItem, VendorDetailCmp},
	props: {
		vendors: {
			type: Array,
			default: () => [],
		},
		deliveryGroups: {
			type: Object,
			default: () => [],
		},
		deliveryClasses: {
			type: Object,
			default: () => [],
		},
		countries: {
			type: Object,
			default: () => [],
		},
		currencies: {
			type: Object,
			default: () => [],
		},
		addresses: {
			type: Object,
			default: () => [],
		},
		mainVendors: {
			type: Object,
			default: () => [],
		},
		shippingServices: {
			type: Array,
			default: () => [],
		},
		user: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			selectedVendor: null,
			searchQuery: "",
			activeState: "",
			deliveryClass: null,
			isVendorEditing: false,
			activeVendorDetailTab: 0,
			//only temporary for import
			vendorImportFile: null,
			vendorImportData: null,
			isRequestInProgress: false,
		};
	},
	computed: {
		filteredVendors() {
			const searchTerm = this.searchQuery ? this.searchQuery.toLowerCase() : "";

			return this.vendors.filter(vendor => {
				const matchesActiveState = this.activeState === "" || String(vendor.isActive) === this.activeState;
				const matchesDeliveryClass = this.deliveryClass === null || vendor.deliveryClass === this.deliveryClass;

				const country = this.countries[vendor.countryId] || {};
				const matchesSearch = searchTerm === "" ||
						vendor.name.toLowerCase().includes(searchTerm) ||
						(vendor.skuPrefix && vendor.skuPrefix.toLowerCase().includes(searchTerm)) ||
						(country.countryName && country.countryName.toLowerCase().includes(searchTerm)) ||
						(country.countryIso && country.countryIso.toLowerCase().includes(searchTerm));

				return matchesActiveState && matchesDeliveryClass && matchesSearch;
			});
		},
		deliveryClassOptions() {
			const entries = Object.entries(this.deliveryClasses);

			return entries
					.slice(0, -1)
					.map(([key, value]) => ({
						value: value,
						text: `LK ${key}`,
					}));
		},
	},
	methods: {
		selectVendor(vendor) {
			if(this.selectedVendor && this.selectedVendor.id === vendor.id) {
				this.selectedVendor = null; // Deselect if the same vendor is clicked
				return;
			}
			this.selectedVendor = vendor;
		},
		handleVendorEditModeChange(isEditing) {
			this.isVendorEditing = isEditing;
		},
		//delete after import
		onVendorImportChange(event) {
			const file = event.target.files ? event.target.files[0] : null;

			if (!file) {
				this.vendorImportFile = null;
				this.vendorImportData = null;
				return;
			}

			this.vendorImportFile = file;

			const reader = new FileReader();

			reader.onload = (e) => {
				const bstr = e.target.result;
				const wb = XLSX.read(bstr, { type: 'binary' });

				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];

				this.vendorImportData = {
					name: file.name,
					data: XLSX.utils.sheet_to_json(ws, { header: 1 }),
				};
			};

			reader.readAsBinaryString(file);
		},

		uploadVendorImport() {
			if (!this.vendorImportData) {
				return;
			}

			this.isRequestInProgress = true;

			axios.post('/vendor/import', {
				fileData: this.vendorImportData,
			})
					.then(() => {
						this.isRequestInProgress = false;

						this.$bvToast.toast('Lieferanten wurden importiert', {
							title: 'Erfolgreich',
							variant: 'success',
							solid: true,
							autoHideDelay: 5000,
						});

						this.vendorImportFile = null;
						this.vendorImportData = null;

					})
					.catch(error => {
						this.isRequestInProgress = false;

						this.modalError = {
							show: true,
							message: 'Folgender Fehler ist aufgetreten',
							error: error.response?.data?.message ?? error.message,
							title: 'Lieferanten Import',
						};
					});
		},
	},
	created() {
	}
}
</script>



<style scoped>
.grid {
	display: grid;
	grid-template-columns: 750px 1fr;
	width: 100%;
	height: 100%;
	gap: 20px
}


/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scrollbar::-webkit-scrollbar {
	display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar {
	-ms-overflow-style: none;  /* IE and Edge */
	scrollbar-width: none;  /* Firefox */
}

</style>